import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './create_type.less'
import CampaignEligibility from 'components/common/campaign_eligibility'
import { getI18n } from 'client/i18n'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'
import { Link } from 'react-router'
import { glimpseRoute } from 'lib/route_utils'
import { HeadingText } from '@paypalcorp/pp-react'
import CreateCard from 'components/common/create_card'
import { trackClick } from 'lib/fpti_analytics'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

export const I18N_CONTEXT = 'components/pages/create/pool_type'
const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES
const i18n = getI18n(I18N_CONTEXT)
const COUNTRY_CODE_DEFAULT = 'US'

class PoolType extends React.Component {
  static propTypes = {
    countryCode: PropTypes.string,
    formattedMaxGoalAmount: PropTypes.string,
    isBusinessAccount: PropTypes.bool,
    isGNCEnabled: PropTypes.bool,
    isCampaignLimitReached: PropTypes.bool,
    money_pool_creation_blocked: PropTypes.bool,
  }

  static defaultProps = {
    countryCode: COUNTRY_CODE_DEFAULT,
  }

  state = {
    showErrorDialog: false,
  }

  componentDidMount() {
    sendEnsightenEvent('MoneyPoolStart')
  }

  limitDialogToggle = () => {
    if (this.props.isCampaignLimitReached)
      this.setState(prevState => ({
        showErrorDialog: !prevState.showErrorDialog,
      }))
  }

  //This Method will be used untill GN elmo is not enabled
  trackGNEvent = () => {
    this.limitDialogToggle()
    trackClick({
      clickName: 'dw_giving_start_create_fundraiser_individual_pressed',
      data: {
        event_name: 'dw_giving_start_create_fundraiser_individual_pressed',
      },
    })
  }

  render() {
    const {
      countryCode,
      isBusinessAccount,
      isGNCEnabled,
      isCampaignLimitReached,
      money_pool_creation_blocked,
    } = this.props
    const gnRoute = !isCampaignLimitReached
      ? glimpseRoute('create-crowdfunding', 'basics', 'create')
      : null
    return (
      <div>
        {this.state.showErrorDialog && (
          <CampaignEligibility
            campaignType={CROWD_FUNDING}
            onClose={this.limitDialogToggle}
            dialog={true}
          />
        )}
        <HeadingText size="md" styleName="title">
          {isGNCEnabled ? i18n('title_gnc') : i18n('title_gn')}
        </HeadingText>
        <div styleName={isGNCEnabled ? 'subHeader' : 'subHeader-gn'}>
          {isGNCEnabled
            ? i18n(`sub_title_gnc_${countryCode}`)
            : i18n('sub_title_gn')}
        </div>
        {isGNCEnabled ? (
          <CreateCard
            to={gnRoute}
            iconName={'money-pools'}
            title={i18n(`campaign_title_${countryCode}`)}
            data_nemo="crowdfunding-pool-link"
            subtitle={i18n('campaign_subtitle', {
              maxGoalAmount: this.props.formattedMaxGoalAmount,
            })}
            event_name={'dw_giving_start_create_fundraiser_individual_pressed'}
            flow="GENEROSITY_NETWORK"
            onClick={this.limitDialogToggle}
          />
        ) : (
          <Link
            to={gnRoute}
            className="vx_btn vx_btn-block"
            styleName="button-cf"
            data-nemo="crowdfunding-pool-link"
            onClick={this.trackGNEvent}
          >
            {i18n('create_your_page')}
          </Link>
        )}

        {isGNCEnabled && (
          <CreateCard
            to={glimpseRoute('create-crowdfunding', 'nonprofit', 'create')}
            iconName={'donate'}
            title={i18n('charity_campaign_title')}
            subtitle={i18n('charity_campaign_subtitle')}
            event_name={'dw_giving_start_create_fundraiser_charity_pressed'}
            flow="GENEROSITY_NETWORK_CHARITIES"
          />
        )}
        {!isBusinessAccount &&
          !money_pool_creation_blocked && (
            <Link
              to={glimpseRoute('create', 'basics')}
              styleName="link"
              data-pa-click="moneypool"
              data-nemo="standard-pool-link"
            >
              {i18n('create_unrelated_page')}
            </Link>
          )}
      </div>
    )
  }
}

export default cssModules(PoolType, styles)
